<ng-template>
  <div class="container">
    <ng-content></ng-content>
  </div>
</ng-template>
